import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/contract-review-choice')({
  staticData: { hideShell: true },
});
